import mitt, {Emitter} from 'mitt';
import {EventNotification, Events} from "@/data/eventbus";

// make it global so the different js chunks all access the same event emitter
(window as any).buggyFitEventBus = (window as any).buggyFitEventBus || mitt<Events>();
const emitter = (window as any).buggyFitEventBus as Emitter<Events>;

export default {
    $on: emitter.on,
    //$once: emitter.once,
    $off: emitter.off,
    $emit: emitter.emit,
    /*
    $emit: (...args: any[]) => {
        console.warn('$emit event: ', args);
        return emitter.emit.apply(this, args as any);
    },
    */

    $notification(notification: EventNotification|string) {
        if( typeof notification === 'string' ) {
            notification = {
                message: notification
            };
        }
        emitter.emit('notification', notification);
    }

    /*
    $on: (...args: any[]) => emitter.on(...args),
    $once: (...args: any[]) => emitter.once(...args),
    $off: (...args: any[]) => emitter.off(...args),
    $emit: (...args: any[]) => emitter.emit(...args),
    */
}
